
import { defineComponent, PropType } from 'vue'
import { Field, ErrorMessage } from 'vee-validate'
import { ModulesIdentifiers } from '@/store'
import { PartnerPropertyGetters } from '@/store/modules/partner-property/getters'
import { PartnerPropertyActions } from '@/store/modules/partner-property/actions'
import { SellDeviceType } from '@/types/partner-property'
import { isInvalid } from '@/utils'

export default defineComponent({
  name: 'CellularServiceTypeSelector',
  components: {
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch(
      `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyActions.GET_CELLULAR_SERVICES}`,
    )
    this.loading = false
  },
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    fieldIdBase: {
      type: String,
      required: true,
    },
    values: {
      type: Object as PropType<{
        stores: { [key: string]: any }[]
        provides_sell_cellular_services: boolean
        cellular_services: string[]
      }>,
      default: () => {
        return { stores: null }
      },
    },
    errors: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  emits: ['changeSelection'],
  methods: {
    isInvalid,
    isOtherSelected(): boolean {
      if (this.loading) return false
      if (this.cellularServiceTypeOptions && this.cellularServiceTypeOther) {
        if (this.index < 0 && this.values.cellular_services) {
          return (
            this.values.cellular_services.findIndex(
              (obj) => obj == this.cellularServiceTypeOther.id,
            ) >= 0
          )
        }
        if (this.values.stores === null) return false
        if (!this.values.stores) return false
        if (
          this.values.stores.length <= 0 ||
          this.values.stores[this.index] === undefined
        )
          return false

        if (this.values.stores[this.index].cellular_services)
          return (
            this.values.stores[this.index].cellular_services.findIndex(
              (obj: string) => obj == this.cellularServiceTypeOther.id,
            ) >= 0
          )
      }
      return false
    },
    getDeviceName(id: string): string {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_CELLULAR_SERVICE_NAME}`
      return this.$store.getters[key](id)
    },
    getCellularServices(): string[] {
      if (this.index < 0) return this.values.cellular_services
      if (this.values.stores === null) return []
      if (!this.values.stores) return []
      if (
        this.values.stores.length <= 0 ||
        this.values.stores[this.index] === undefined
      )
        return []
      return this.values.stores[this.index].cellular_services
    },
    existCellularServices(): boolean {
      if (this.index < 0)
        return (
          this.values.cellular_services &&
          this.values.cellular_services.length > 0
        )
      if (this.values.stores === null) return false
      if (!this.values.stores) return false
      if (
        this.values.stores.length <= 0 ||
        this.values.stores[this.index] === undefined
      )
        return false
      return (
        this.values.stores[this.index].cellular_services &&
        this.values.stores[this.index].cellular_services.length > 0
      )
    },
  },
  computed: {
    cellularServiceTypeOptions(): SellDeviceType[] {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_CELLULAR_SERVICES}`
      return this.$store.getters[key]
    },
    cellularServiceTypeOther(): SellDeviceType {
      const key = `${ModulesIdentifiers.PARTNER_PROPERTY}/${PartnerPropertyGetters.GET_OTHER_CELLULAR_SERVICE}`
      return this.$store.getters[key]
    },
  },
})
